import { Sweepstakes } from "@shared/components";
import { useLobbyParams } from "@shared/hooks/lobby/lobby";
import { useUser } from "@shared/hooks/user";
// import { RegistrationButtonLink } from "@shared/pages/registration/registration-module";
import React from "react";
import { Link } from "react-router-dom";

import Navigation from "../Navigation/Navigation";

import Login from "./Login";

const Bottom = (props) => {
  const lobbyParams = useLobbyParams();
  const user = useUser();

  return (
    <div className="header__bot">
      <div className="logo-wrapper">
        <Link to="/" className="logo" />
      </div>
      {/*<div className="reg-btn-wrapper">*/}
      {/*  <RegistrationButtonLink />*/}
      {/*</div>*/}
      <Login {...props} />
      {lobbyParams?.sweepstakes && (
        <div className="sweepstakes-desktop-header">
          {" "}
          <Sweepstakes user={user} />{" "}
        </div>
      )}
      <Navigation />
    </div>
  );
};

export default Bottom;
